var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-items-edit',{attrs:{"content-type":"galleries","content-type-singular":"gallery","content-name":"Galleries","content-name-singular":"Gallery"}})}
var staticRenderFns = []

export { render, staticRenderFns }